// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1nTgT","text":"SelectPayment_text__1iNAd","title":"SelectPayment_title__3A3_Q","btn":"SelectPayment_btn__31LBp"};